import React, { useEffect, useState, useRef, useLayoutEffect, useCallback } from 'react';
import ImportScript from '../../../../hooks/importScript'
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer'
import { createToken } from '../../../../services/tableau/tableau.service';

const ExternalLink = ({ link }) => {
  ImportScript("https://core.analyticsforschools.com.au/javascripts/api/tableau.embedding.3.latest.min.js");
  const [token, setToken] = useState(null)

  // Todo el uso de dimensiones es solo para re renderizar y que el componente de tableau 
  // se reajuste al hacer resizing de la pantalla
  const [, setDimensions] = useState({width:0, height:0});

  const analyticsRef = useRef()

	const getDimensions = () => {
		return {
			width: analyticsRef.current ? analyticsRef.current.clientWidth : 0,
			height: analyticsRef.current ? analyticsRef.current.clientHeight : 0
		};
	};

	const handleResize = useCallback( (e) => {
    return setDimensions(getDimensions());
	}, [setDimensions])

	useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
	}, [handleResize]);

	useLayoutEffect(() => {
    handleResize();
	}, [handleResize]);

 // Hasta aqui el truco de re renderizado de tableau

  useEffect( () => {
    const fetchToken = async () => {
      try {
        const response = await createToken()
        if (!response.data && response.error) {
          console.error(response.error.message)
        } else {
          setToken(response.data)
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchToken()
  },[link])

  const BASE_URL = "https://core.analyticsforschools.com.au/views/"

  return (
    <AutoSizer>
      {({ height, width }) => (
        <div ref={analyticsRef} style={{'width':`${width}px`, 'height':`${height}px`}}  >
          {token &&
            <tableau-viz id="tableauViz"
                src={`${BASE_URL}${link}`}
                toolbar="hidden"
                token={token}
                hide-edit-button={true}
                hide-edit-in-desktop-button={true}
                width={`${width}px`}
                height={`${height}px`}
                // hide-tabs="false"
            >
            </tableau-viz>
          }
        </div>
      )}
    </AutoSizer>
  )
}

export default ExternalLink